import { Pipe, PipeTransform } from '@angular/core';
import { Field } from '../../../../services';

@Pipe({
  name: 'getValidationMsgs'
})
export class GetValidationMsgsPipe implements PipeTransform {

  transform(field: Field): string[] {
    const validations = [];

    if (field.properties.isRequired) {
      validations.push('REQUIRED');
    }

    if (field.name === 'code') {
      validations.push('CODE');
    }

    return validations;
  }

}
